import _asyncToGenerator from'@babel/runtime/helpers/asyncToGenerator';import _slicedToArray from'@babel/runtime/helpers/slicedToArray';import _regeneratorRuntime from'@babel/runtime/regenerator';import React,{useState,useEffect}from'react';import PropTypes from'prop-types';import {THEMES,extendTheme,ThemeProvider}from'@manulife/mux';import CoBrandingContext from'./CoBrandingContext.js';import useCIAMContextParam from'../../hooks/useCIAMContextParam.js';import useSessionStorage from'../../hooks/useSessionStorage.js';var DEFAULT_THEME = THEMES.canadianTheme;
function CoBrandingProvider(props) {
  var hostUrl = props.hostUrl,
    children = props.children;
  var brandingCode = useCIAMContextParam('brand');
  var _useSessionStorage = useSessionStorage("ciam.branding.".concat(brandingCode), null),
    _useSessionStorage2 = _slicedToArray(_useSessionStorage, 2),
    brandValues = _useSessionStorage2[0],
    setBrandValues = _useSessionStorage2[1];
  var _useState = useState(DEFAULT_THEME),
    _useState2 = _slicedToArray(_useState, 2),
    theme = _useState2[0],
    setTheme = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isBrandValuesLoaded = _useState4[0],
    setIsBrandValuesLoaded = _useState4[1];
  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var coBranding, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!brandValues) {
                _context.next = 3;
                break;
              }
              // We already have the brand values, so no need to do anything
              setIsBrandValuesLoaded(true);
              return _context.abrupt("return");
            case 3:
              coBranding = {};
              if (!brandingCode) {
                _context.next = 18;
                break;
              }
              _context.prev = 5;
              _context.next = 8;
              return fetch("".concat(hostUrl, "/").concat(brandingCode, ".json"));
            case 8:
              response = _context.sent;
              if (!response.ok) {
                _context.next = 14;
                break;
              }
              _context.next = 12;
              return response.json();
            case 12:
              coBranding = _context.sent;
              setBrandValues(coBranding);
            case 14:
              _context.next = 18;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](5);
            case 18:
              setBrandValues(coBranding, false);
              setIsBrandValuesLoaded(true);
            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 16]]);
    }))();
  }, [hostUrl, brandingCode, brandValues, setBrandValues, setTheme]);
  useEffect(function () {
    // As per the suggestion in https://mux.manulife.com/docs/v3-4-release
    setTheme(extendTheme(brandValues === null || brandValues === void 0 ? void 0 : brandValues.theme, DEFAULT_THEME));
  }, [brandValues, setTheme]);

  // Until the value is set, don't render anything to avoid color pop-in
  if (!isBrandValuesLoaded) {
    return null;
  }
  return /*#__PURE__*/React.createElement(CoBrandingContext.Provider, {
    value: brandValues
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, children));
}
process.env.NODE_ENV !== "production" ? CoBrandingProvider.propTypes = {
  hostUrl: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
} : void 0;export{CoBrandingProvider as default};